import { humanizeKey } from './profile-explanation-utils';
import { PROFILE_CAPABILITIES } from "../../../../models/ProfileCapabilities";

/**
 * Capability options for the Profiles troubleshooting page dropdown.
 * Dynamically constructed from PROFILE_CAPABILITIES enum.
 * Values match backend ProfileCapability enum (shopify-app).
 */
export interface IProfileCapabilityOption {
    value: string;
    label: string;
}

export const PROFILE_CAPABILITY_OPTIONS: IProfileCapabilityOption[] = [
    { value: 'all', label: 'All' },
    ...Object.values(PROFILE_CAPABILITIES).map(value => ({
        value,
        label: humanizeKey(value)
    }))
];
